<template>
    <div class="bg" v-show="show" ref="bg">
        <template v-if="alertType === 'countdown'">
            <div class="box">
                <img class="titleImg" src="http://source.weicistudy.com/draw/clock.png" alt="">
                <p class="msg">不要心急呦！抽奖时间还没到，想要了解具体抽奖时间可查看详情活动规则介绍。</p>
                <p class="checkRule">
                    <img  class="btn" @click="checkRule" src="http://source.weicistudy.com/draw/activity-rule.png" alt="">
                </p>
                <a href="javascript:;" class="close">
                    <img src="http://source.weicistudy.com/draw/close.png" @click="closeDialog" alt="">
                </a>
            </div>
        </template>
        <template v-else-if = "alertType === 'winning'">
            <div class="prize">
                <img class="sun" src="http://source.weicistudy.com/draw/sunshine.png" alt="">
                <div class="prize-box">
                    <!--<img class="prizeImg" src="@/assets/images/inprize.png" alt="">-->
                    <span class="tit">恭喜您！获得Apple iPhone XS<br>64GB 手机一部，工作人员会在<br>2月20日后与您取得联系。</span>
                </div>
                <a href="javascript:;" class="close">
                    <img src="http://source.weicistudy.com/draw/close.png" @click="closeDialog" alt="">
                </a>
            </div>
        </template>
        <template v-else-if="alertType === 'noprize'">
            <div class="nowin" ref="nowin">
                <img class="bg-nowin" src="http://source.weicistudy.com/draw/noprize-bg@3x.png" alt="">
                <img class="l-fire fire" src="http://source.weicistudy.com/draw/left-fireworks.png" alt="">
                <img class="r-fire fire" src="http://source.weicistudy.com/draw/right-fireworks.png" alt="">
                <div class="greeting-box">
                    <div class="greeting">
                        <span class="title">{{showText()}}</span>
                    </div>
                </div>
                <img class="thanks" src="http://source.weicistudy.com/draw/thanks.png" alt="">
                <a href="javascript:;" class="close">
                    <img src="http://source.weicistudy.com/draw/close.png" @click="closeDialog" alt="">
                </a>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'PrizeAlert',
        data() {
            return {
                showing: false
            }
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            alertType: {
                type: String,
                default: 'noprize' // countdown:倒计时；winning:中奖；noprize: 未中奖
            }
        },
        // mounted () {
        //     if (this.alertType === 'noprize') {
        //         console.log(document.documentElement.clientHeight)
        //         let viewHeight = document.documentElement.clientHeight
        //         let boxHeight = parseInt(getComputedStyle(this.$refs.nowin, null).getPropertyValue('height'))
        //         let bottomDistance = (viewHeight - boxHeight)/2
        //         this.$refs.nowin.style.bottom = bottomDistance + 'px'
        //         this.$refs.nowin.style.transition = 'bottom 1s'
        //     }
        // },
        methods: {
            closeDialog() {
                this.$emit('close')
            },
            checkRule() {
                this.$emit('rule')
            },
            touchHandle(e) {
                e.stopPropagation();
                e.preventDefault();
            },
            showText() {
                let index = Math.floor(Math.random() * 4 + 1)
                let textAry = ['金猪贺岁 欢乐祥瑞', '金猪拱门 五福临门', '金猪打滚 财源滚滚', '金猪祈福 阖家幸福']
                return textAry.slice(index - 1, index)[0]
            }
        },
        mounted() {
            window.document.querySelector('.bg').addEventListener('touchmove', this.touchHandle, false);
        }
    };
</script>

<style scoped>
    @keyframes rotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(3220deg);
        }
    }
    @keyframes showup {
        0% {
            bottom:-276px;
        }
        100% {
            bottom:106px;
        }
    }
    @keyframes l-blooming {
        0%{
            transform: scale(0);  /*开始为原始大小*/
        }
        5%{
            transform: scale(0.05); /*放大1.1倍*/
        }
        10%{
            transform: scale(0.1); /*放大1.1倍*/
        }
        15%{
            transform: scale(0.15); /*放大1.1倍*/
        }
        20%{
            transform: scale(0.2); /*放大1.1倍*/
        }
        25%{
            transform: scale(0.25); /*放大1.1倍*/
        }
        30%{
            transform: scale(0.3); /*放大1.1倍*/
        }
        35%{
            transform: scale(0.35); /*放大1.1倍*/
        }
        40%{
            transform: scale(0.4); /*放大1.1倍*/
        }
        45%{
            transform: scale(0.45); /*放大1.1倍*/
        }
        50%{
            transform: scale(0.500);
        }
        55%{
            transform: scale(0.55); /*放大1.1倍*/
        }
        60%{
            transform: scale(0.60); /*放大1.1倍*/
        }
        65%{
            transform: scale(0.65); /*放大1.1倍*/
        }
        70%{
            transform: scale(0.7); /*放大1.1倍*/
        }
        75%{
            transform: scale(0.75);
        }
        80%{
            transform: scale(0.8); /*放大1.1倍*/
        }
        85%{
            transform: scale(0.85); /*放大1.1倍*/
        }
        90%{
            transform: scale(0.9); /*放大1.1倍*/
        }
        95%{
            transform: scale(0.95); /*放大1.1倍*/
        }
        100%{
            transform: scale(1);
        }

    }
    .bg {
        position: fixed;
        top:0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .8);
    }
    .box {
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        background: url('http://source.weicistudy.com/draw/public/bg-unapply.png');
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 100px 41px 0;
        width: 520px;
        height: 468px;
    }
    .titleImg {
        position: absolute;
        left:50%;
        top:-190px;
        transform: translate(-50%);
        width: 400px;
    }
    .msg {
        color: #ffffff;
        text-shadow:0px 5px 0px rgba(41,38,33,0.2);
        width: 100%;
        line-height: 60px;
        text-indent: 60px;
        font-size: 32px;
    }
    .checkRule {
        width: 100%;
        text-align: center;
        margin-top: 51px;
        margin-bottom: 40px;
    }
    .btn {
        width: 410px;
        /*position: absolute;*/
        /*bottom:40px;*/
    }
    .close {
        position: absolute;
        left:50%;
        bottom: -122px;
        transform: translate(-50%);
        width: 72px;
    }
    .close img {
        width: 100%;
    }
    .prize {
        width: 100%;
        text-align: center;
        position: absolute;
        top:50%;
        transform: translateY(-60%);
    }
    .prize .close {
        bottom: -102px;
    }
    .prize .sun {
        width:622px;
        height:620px;
        animation: rotate 120s infinite linear;
        animation-fill-mode:forwards
    }
    .prize .prize-box {
        position: absolute;
        top:44px;
        left:36px;
        width: 600px;
        height: 540px;
        background-image: url('http://source.weicistudy.com/draw/inprize.png');
        background-size: 100% 100%;
    }
    .prize-box .tit {
        position: absolute;
        text-align: left;
        left:135px;
        bottom:37px;
        font-size:28px;
        font-weight:normal;
        color:rgba(255,255,255,1);
        text-shadow:0px 5px 0px rgba(41,38,33,0.2);
    }
    .nowin {
        position: absolute;
        width: 520px;
        height: 374px;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .nowin .bg-nowin {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
    }
    .greeting-box {
        position: absolute;
        width: 520px;
        height: 574px;
        left: 0;
        bottom:0;
        overflow: hidden;
        z-index: 2;
    }
    .greeting {
        position: absolute;
        background-image: url('http://source.weicistudy.com/draw/greeting.png');
        background-size: 100% 100%;
        bottom:-276px;
        left: 44px;
        width: 434px;
        height: 376px;
        box-sizing: border-box;
        padding-left:88px;
        padding-top:234px;
        animation: showup 1s;
        animation-fill-mode:forwards
    }
    .greeting .title {
        font-size: 30px;
        color: #C1571D;
    }
    .thanks {
        position: absolute;
        bottom:0;
        left:5px;
        width: 510px;
        z-index: 3;
    }
    .nowin .fire {
        position: absolute;
        width: 170px;
        height: 189px;
        animation: l-blooming 1.5s infinite;
        animation-fill-mode:forwards
    }
    .nowin .l-fire {
        left:-84px;
        bottom:16px;
        z-index: 0;
    }
    .nowin .r-fire {
        top:-176px;
        right:-30px;
    }
</style>